import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
import Breadcrumbs from '@mui/material/Breadcrumbs';

import Loader from '../Loader/Loader';

import './ImageGallery.css'
import SingleImage from './SingleImage';

const GALLERY_URL = '/gallery'

function ImageGallery() {
    
  const [images, setImages] = useState('')


  useEffect(() => {
      async function getImages() {
          try {
              const response = await axios.get(process.env.REACT_APP_DEPT_API + GALLERY_URL);
              setImages(response.data);
          } catch (error) {
              console.error(error);
          }
      }
      getImages()
  }, [])

  const sortedImages = images && images.sort((a, b) => a.order_no < b.order_no ? -1 : 1)

  return (
    <div className='imageGallery'>
        <div className='section__container'>
            <div className='section'>
              <Breadcrumbs aria-label="breadcrumb">
                  <Link to="/" className='breadcrumb__link'>
                      Home
                  </Link>
                  <Link to="" className='breadcrumb__link bold'>
                      Gallery
                  </Link>
              </Breadcrumbs>
            </div>
            <div className='section'>
                <h1 className='section__header'>Our Gallery</h1>

                <div className='imageGallery__container'>
                  {sortedImages ? sortedImages.map((image) => (
                      <SingleImage 
                        key={image._id}
                        image={image.image.url}
                        title={image.title}
                      />
                  )) : <Loader color="#AE9142" size={80}/>}
                </div>
            </div>
        </div>
    </div>
  )
}

export default ImageGallery